module.exports = __webpack_public_path__ + "img/accueil-entete-portrait.b2a46b5d.jpg";